import { createContext } from 'react';

export const AppDataContext = createContext(null);